export const PURCHASED_PRODUCTS_HYPERLINK_TYPE = 'PURCHASED_PRODUCTS';
export const RANDOMIZATION_HYPERLINK_TYPE = 'RANDOMIZATION';
